import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "concierge";

export type ConciergeChatResponse = AgentChatResponse;

export async function createConciergeSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingConciergeSession(sessionId: string): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamConciergeMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<ConciergeChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Concierge agent error",
  );
}
